/*
 * @Author: tkp
 * @Date: 2021-11-20 16:40:50
 */
import http from './http'

//获取oss路径url获取密钥
export function generatePresignedUrl(params) {
    return http.post(`/amaos/file/generatePresignedUrl`, params)
}



// WEBPACK FOOTER //
// ./src/utils/api.js